import { render, staticRenderFns } from "./TopClientes.vue?vue&type=template&id=344c4a93&scoped=true"
import script from "./TopClientes.vue?vue&type=script&lang=js"
export * from "./TopClientes.vue?vue&type=script&lang=js"
import style0 from "./TopClientes.vue?vue&type=style&index=0&id=344c4a93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c4a93",
  null
  
)

export default component.exports